import type { StudentsQuery } from '@innovamat/glow-api-client';
import { useStudentsQuery } from '@innovamat/glow-api-client';
import { useEffect, useState } from 'react';
import { useCurrentNavigationValues } from '../../../../contents';
import { useOrganization } from '../../../hooks/use-organization';
import type { StudentRow } from '../classroom-students';

function useStudents() {
  const { currentClassroom } = useCurrentNavigationValues();
  const { organization } = useOrganization();
  const classroomId = currentClassroom?.id;

  const [students, setStudents] = useState<StudentRow[]>([]);
  const { data, isPending, isError } = useStudentsQuery<{
    students: StudentRow[];
  }>(
    { classroomId: classroomId!, organizationId: organization?.id },
    { enabled: !!classroomId }
  );

  const filterStudents = (students: StudentsQuery['students']) => {
    return students?.map((student) => ({
      ...student,
      parents:
        student?.parents?.filter((parent) => parent?.userInfo?.email) || [],
    }));
  };

  useEffect(() => {
    if (data?.students) {
      setStudents(filterStudents(data.students) as StudentRow[]);
    }
  }, [data]);

  return {
    students,
    setStudents,
    isPending,
    isError,
    cacheStudents: filterStudents(data?.students),
  };
}

export { useStudents };
